module.exports = __webpack_public_path__ + "img/abouticon.b8c5615d.svg";